import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const userRetentionGraphApi = createAsyncThunk(
    'auth/UserRetentionGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { type, params } = requestData;
            const response = await AuthAxios.get(apiRoutes.userRetentionGraph(`${type}`), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "" }

const userRetentionGraphSlice = createSlice({
    name: 'UserRetentionGraph/graph',
    initialState: initialState,
    reducers: {
        resetUserRetentionGraph: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(userRetentionGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(userRetentionGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(userRetentionGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetUserRetentionGraph } = userRetentionGraphSlice.actions;
export const userRetentionGraphReducer = userRetentionGraphSlice.reducer